import { Tile } from '@components/shared/tile.component';
import { Button } from '@components/ui/button';
import { Skeleton } from '@components/ui/skeleton';
import { useGetMeiaMissionThreads } from '@queries/meia.query';
import type { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { meiaRoute } from '../meia.constants';
import { MeiaThreadPickerCard, MeiaThreadPickerTileTitle } from './meia-thread-picker-card.component';

type MeiaThreadTabsTileProps = {
  canEdit: boolean;
  missionId: string;
  onSelectThread: (threadId: string) => void;
  selectedThreadId: string | null;
  studyId: string;
};

export const MeiaThreadTabsTile: FC<MeiaThreadTabsTileProps> = (props) => {
  const { canEdit, missionId, onSelectThread, selectedThreadId, studyId } = props;
  const navigate = useNavigate();
  const { data: threads = [], isLoading } = useGetMeiaMissionThreads({ missionId, studyId });

  const addThreadHref = meiaRoute.studyTab({ query: { action: 'addThread', missionId }, studyId, tab: 'p2' });

  if (isLoading) {
    return (
      <Tile header={{ title: <MeiaThreadPickerTileTitle /> }}>
        <Skeleton className="h-20 w-full" />
      </Tile>
    );
  }

  if (threads.length === 0) {
    return (
      <Tile
        emptyState={{
          action: canEdit ? (
            <Button
              asChild
              variant="link"
            >
              <Link to={addThreadHref}>Add Mission Thread</Link>
            </Button>
          ) : undefined,
          title: 'No Mission Threads',
        }}
        isEmpty
      >
        <span />
      </Tile>
    );
  }

  return (
    <Tile
      contentClassName="gap-3"
      header={{
        button: canEdit ? { onClick: () => navigate(addThreadHref), text: '+ Add Thread in P2' } : undefined,
        title: <MeiaThreadPickerTileTitle />,
      }}
    >
      <div className="flex flex-wrap gap-2">
        {threads.map((thread) => (
          <MeiaThreadPickerCard
            isSelected={selectedThreadId === thread.id}
            key={thread.id}
            onSelect={() => onSelectThread(thread.id)}
            studyId={studyId}
            thread={thread}
          />
        ))}
      </div>
    </Tile>
  );
};
